import { queryAuthCateInfo } from "@/api/dmp_common";
import { AuthCate2InfoListItem } from "@/api/dmp_common/interface";
import { Cascader } from "@ad/anq-ui";
import { useEffect, useState } from "react";
import { IProps as CascaderProps } from "@ad/anq-ui/lib/cascader/Checkable";

interface Props
  extends Omit<
    CascaderProps,
    "hideResultPanel" | "type" | "onChange" | "dataSource"
  > {
  onChange?: (cateId: string[]) => void;
  /** 上次选择的类目保存在localStorage */
  storageKey?: string;
  initFirst?: boolean;
  allowClear?: boolean;
}

/** @deprecated check ./new */
const CascaderSelectCate = (props: Props) => {
  const { onChange, storageKey, initFirst, allowClear, ...restProps } = props;
  const [cateListTree, setCateListTree] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  useEffect(() => {
    getCate2lList();
  }, []);

  useEffect(() => {
    if (selectedKeys?.[1]) {
      onChange?.(selectedKeys);
    }
  }, [selectedKeys]);

  const getInitialCate = (list: AuthCate2InfoListItem[] = []) => {
    if (list.length) {
      if (storageKey) {
        const localCateId = localStorage.getItem(storageKey);

        // 如果localStorage中有值，且该值在当前类目列表中，则使用localStorage中的值
        if (localCateId) {
          const [cate1Id, cate2Id] = localCateId.split(",");

          if (
            list.find(
              (item) =>
                item.cate1Id === Number(cate1Id) &&
                item.cate2Id === Number(cate2Id)
            )
          ) {
            setSelectedKeys([cate1Id, cate2Id]);
            return;
          }
        }

        // 否则使用第一个类目
        const cateId = [String(list[0].cate1Id), String(list[0].cate2Id)];
        setSelectedKeys(cateId);
        localStorage.setItem(storageKey, cateId.join(","));
      } else if (initFirst) {
        const cateId = [String(list[0].cate1Id), String(list[0].cate2Id)];
        setSelectedKeys(cateId);
        localStorage.setItem(storageKey, cateId.join(","));
      }
    }
  };

  const getCate2lList = async () => {
    const ret = await queryAuthCateInfo({ showAllCates: false });

    if (ret?.success) {
      getCateListTree(ret?.result?.authCate2InfoList);
    }
  };

  const handleCateChange = (v: string[]) => {
    setSelectedKeys(v);
    if (storageKey) {
      localStorage.setItem(storageKey, v.join(","));
    }
  };

  const getCateListTree = (list: AuthCate2InfoListItem[]) => {
    const tree = [];
    const cate1Map = {};

    list?.forEach((cate) => {
      cate1Map[cate.cate1Id] = cate1Map[cate.cate1Id] || {
        cate1Id: cate.cate1Id,
        cate1Name: cate.cate1Name,
        children: [],
      };

      if (
        !cate1Map[cate.cate1Id].children.find(
          (item) => item.cate2Id === cate.cate2Id
        )
      ) {
        cate1Map[cate.cate1Id].children.push({
          cate2Id: cate.cate2Id,
          cate2Name: cate.cate2Name,
        });
      }
    });

    Object.keys(cate1Map).forEach((cate1Id) => {
      tree.push(cate1Map[cate1Id]);
    });

    const cateTree = tree.map((item) => ({
      key: item.cate1Id,
      title: item.cate1Name || "所有类目",
      children: item.children.map((child) => ({
        key: `${child.cate2Id}`,
        title: child.cate2Name,
        value: "12123",
      })),
    }));

    setCateListTree(cateTree);
    getInitialCate(list);
  };

  return (
    <Cascader.SingleSelect
      placement="bottomRight"
      dataSource={cateListTree}
      selectedKeys={selectedKeys}
      onChange={handleCateChange}
      style={{ width: 280 }}
      allowClear={allowClear}
      {...restProps}
    />
  );
};

export default CascaderSelectCate;
